module.exports = __webpack_public_path__ + "static/media/measure-ruler.480b777a.svg";